export const authenticationType = {
    BASIC_AUTH : "basicauth",
    OAUTH : "oauth",
    APIKEY:"apikey",
};